// Razorpay checkout helper — loads the SDK script on demand and opens the popup.
// Frontend never handles secrets. Amount and order_id come from the backend.

let _scriptPromise = null;

function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => {
      _scriptPromise = null;
      reject(new Error("Could not load Razorpay checkout"));
    };
    document.head.appendChild(s);
  });
  return _scriptPromise;
}

/**
 * Open the Razorpay checkout popup.
 * @param {object} order  - response from POST /api/payments/create-order
 * @param {string} itineraryTitle - itinerary title (shown as description)
 * @returns {Promise<{razorpay_order_id:string,razorpay_payment_id:string,razorpay_signature:string}>}
 */
export async function openRazorpayCheckout(order, itineraryTitle) {
  await loadRazorpay();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "Nirno",
      description: itineraryTitle || "Itinerary purchase",
      image: "/logo.svg",
      prefill: {
        name: order.buyer_name || "",
        email: order.buyer_email || "",
      },
      theme: { color: "#E63946" },
      handler: (resp) => resolve(resp),
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.on("payment.failed", (resp) =>
      reject(new Error(resp.error?.description || "Payment failed"))
    );
    rzp.open();
  });
}
